import { FormGroup, FormControlLabel } from 'beam/dist/Form'
import fieldPropTypes from './FieldPropTypes'
import NumberSpinner from './NumberSpinner'
import { get } from 'lodash'

const FormNumberSpinnerField = props => {
  const { label, field, classes, form, numberSpinnerProps, showErrorBeforeTouched, required, form: { errors, touched } } = props

  const updateNumberSpinnerValue = newValue => {
    form.setFieldValue(field.name, newValue)
  }

  return (
    <FormGroup classes={classes}>
      <FormControlLabel
        label={label}
        control={
          <NumberSpinner
            {... field}
            {... numberSpinnerProps}
            name = {field.name}
            error={(!!showErrorBeforeTouched || !!get(touched, field.name)) && !!get(errors, field.name)}
            helperText={get(errors, field.name)}
            value = {field.value}
            onChange = {updateNumberSpinnerValue}
          />
        }
        required={required}
      />
    </FormGroup>
  )
}

FormNumberSpinnerField.propTypes = fieldPropTypes

export default FormNumberSpinnerField
